var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.583,6.373c-0.229,-1.004 -0.907,-1.796 -1.769,-2.068c-1.559,-0.487 -7.814,-0.487 -7.814,-0.487c0,0 -6.252,0 -7.814,0.487c-0.859,0.268 -1.537,1.06 -1.769,2.068c-0.417,1.822 -0.417,5.627 -0.417,5.627c0,0 0,3.805 0.417,5.627c0.229,1.004 0.907,1.796 1.769,2.068c1.562,0.487 7.814,0.487 7.814,0.487c0,0 6.255,0 7.814,-0.487c0.859,-0.268 1.537,-1.06 1.769,-2.068c0.417,-1.822 0.417,-5.627 0.417,-5.627c0,0 0,-3.805 -0.417,-5.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.002,15l5.196,-3l-5.196,-3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24h-24Z",
    transform: "matrix(6.12323e-17,-1,1,6.12323e-17,0,24)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "static/media/Youtube.2a07f9e42b6e578487fe8587bc277f72.svg";
export { MemoForwardRef as ReactComponent };